import { render, staticRenderFns } from "./AssociateBusinessRequirement.vue?vue&type=template&id=6389277e"
import script from "./AssociateBusinessRequirement.vue?vue&type=script&lang=js"
export * from "./AssociateBusinessRequirement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports